import dayjs from 'dayjs';
export const getEndDateFromRange = (range) => {
    if (!range)
        return;
    const to = dayjs(range.to).utc();
    return `As of ${to.format('MMM D')}`;
};
